import type PopperJS from '@popperjs/core';

export const maxHeight = ({ bottomSpacing = 0 }) => ({
  name: 'maxHeight',
  enabled: true,
  phase: 'beforeWrite' as const,
  requires: ['maxSize'],
  fn({ state }: { state: PopperJS.State }) {
    const { height } = state.modifiersData.maxSize;
    state.styles.popper = {
      ...state.styles.popper,
      maxHeight: `${height - bottomSpacing}px`
    };
  }
});
